export default __webpack_public_path__ + "static/media/pro.0a45cab1.png";